export default {"src":"/_next/static/media/xzc.6c3b2cb6.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};